import { Link } from 'react-router-dom';

const categoryData = [
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-line',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20cinematic%20scene%20with%20elegant%20costumes%20warm%20lighting%20traditional%20Chinese%20architecture%20film%20set%20photography&width=800&height=600&seq=mahua-cat-dianshiju&orientation=landscape',
    desc: '热门剧集 持续更新',
  },
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=movie%20theater%20big%20screen%20with%20dramatic%20cinematic%20lighting%20red%20velvet%20curtains%20film%20projector%20beam%20atmospheric%20photography&width=800&height=600&seq=mahua-cat-dianying&orientation=landscape',
    desc: '院线大片 高清呈现',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-live-line',
    image: 'https://readdy.ai/api/search-image?query=colorful%20TV%20studio%20stage%20with%20bright%20spotlights%20variety%20show%20production%20set%20vibrant%20energetic%20atmosphere%20entertainment%20photography&width=800&height=600&seq=mahua-cat-zongyi&orientation=landscape',
    desc: '热门综艺 欢乐不断',
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-emotion-line',
    image: 'https://readdy.ai/api/search-image?query=anime%20art%20studio%20with%20vibrant%20illustrations%20colorful%20character%20designs%20on%20display%20animation%20style%20creative%20workspace%20photography&width=800&height=600&seq=mahua-cat-dongman&orientation=landscape',
    desc: '国漫崛起 热血追番',
  },
];

export default function CategorySection() {
  return (
    <section className="py-16 bg-background-100">
      <div className="container-page">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">多品类内容，满足您的不同观影需求</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {categoryData.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden aspect-[4/3] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/90">
                    <i className={`${cat.icon} text-lg text-background-50`}></i>
                  </div>
                </div>
                <h3 className="text-lg font-heading font-bold text-white">{cat.name}</h3>
                <p className="text-xs text-white/70 mt-1">{cat.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}